import apiService from 'frontcore/data/api-service/api-service'
import HttpStatusCode from 'frontcore/data/api-service/http-status-code'
import { IProductionHierarchyAPIService, ProductionHierarchy } from 'frontcore/domain/production-hierarchy/types'
import { ProductionHierarchyAPIServiceError } from 'frontcore/data/production-hierarchy/types'


const PRODUCTION_HIERARCHY_API_URL = 'production-hierarchy'

type ProductionHierarchyAPIResponse = {
  id: number
  created: string
  updated: string
  children: number[]
  products: number[]
  deletable: boolean
  name: string
  enabled: boolean
  description: string
  level: number
  parent: number
  device_update: string
}

const parseProductionHierarchyAPIResponse = (productionHierarchyAPIResponse: ProductionHierarchyAPIResponse[]): ProductionHierarchy[] => {
  return productionHierarchyAPIResponse.map(productionHierachy => {
    return {
      id: productionHierachy.id,
      name: productionHierachy.name,
      description: productionHierachy.description,
      enabled: productionHierachy.enabled,
      parent: productionHierachy.parent,
      children: productionHierachy.children,
      products: productionHierachy.products,
      level: productionHierachy.level,
      deletable: productionHierachy.deletable,
      updated: productionHierachy.updated,
      created: productionHierachy.created,
    }
  })
}

export default class ProductionHierarchyAPIService implements IProductionHierarchyAPIService {
  async fetch (): Promise<ProductionHierarchy[]>{
    try {
      const url = `${PRODUCTION_HIERARCHY_API_URL}/`
      const response = await apiService
        .buildRequest()
        .withSessionToken()
        .get<ProductionHierarchyAPIResponse[]>(url)

      if (response.status !== HttpStatusCode.OK) {
        throw new ProductionHierarchyAPIServiceError()
      }

      return parseProductionHierarchyAPIResponse(response.data)

    } catch(e) {
      if (e instanceof ProductionHierarchyAPIServiceError) { throw e }
      throw new ProductionHierarchyAPIServiceError((e as Error).message)
    }
  }
}
